import { Injectable } from '@angular/core';
import { InveniasActionConfigurations } from './invenias-action-configurations';
import { ITriggerConfigService } from './itriggerconfig.service';
import { ITriggerConfig } from './shared-action-configurations';

@Injectable({
  providedIn: 'root',
})
export class InveniasTriggerConfigService implements ITriggerConfigService {
  getConfigs(): ITriggerConfig[] {
    return InveniasActionConfigurations.triggerConfigs;
  }
}
